import Greeting from './greeting'

export default Greeting